module.exports = __webpack_public_path__ + "img/logo.e2ded765.png";